import React, { useEffect, useRef, useState } from 'react';

import { Pencil, Trash, Plus, Search, FileText } from 'lucide-react';
import { useAdmin } from '../AdminLayout/AdminProvider';

import Modal from "react-modal";
import { Eye, Image as ImageIcon } from "lucide-react";
import axios from 'axios';
import { GoogleMap, Marker, Polygon, useJsApiLoader } from "@react-google-maps/api";
import Autocomplete from "react-google-autocomplete";


Modal.setAppElement("#root");


const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.6)",
    zIndex: 1000,
  },
  content: {
    inset: "50% auto auto 50%",
    transform: "translate(-50%, -50%)",
    padding: 0,
    borderRadius: "12px",
    border: "none",
    maxHeight: "85vh",
    overflow: "hidden",
  },
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px 18px",
  background: "#8b306d",
  color: "#fff",
};

const modalBody = {
  padding: "16px",
  overflowY: "auto",
  maxHeight: "70vh",
};


const API_BASE = "https://api.propertygalleria.in/master/api";
const API_BASEE = "http://localhost:4001";
const API = "https://api.propertygalleria.in";

const GOOGLE_MAPS_APIKEY = "AIzaSyAmGcPTfePx1WqX-8bqlPno6-5hU_GE9uA";

export const ProjectMaster = () => {
  const { projectHeads, associates, projects, zones, addProject, updateProject, deleteProject, propertyOwners } = useAdmin();

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');



  const [mediaModalOpen, setMediaModalOpen] = useState(false);
  const [agentModalOpen, setAgentModalOpen] = useState(false);

  const [selectedMedia, setSelectedMedia] = useState({
    images: [],
    documents: [],
  });

  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState(null);

  const [categoriesP, setCategoriesP] = useState([]);

  const [mapCenter, setMapCenter] = useState({ lat: 17.385044, lng: 78.486671 });
  const [boundaryPoints, setBoundaryPoints] = useState([]);
  const [plotArea, setPlotArea] = useState(0);
  const [mapModal, setMapModal] = useState(false);
  const [mapType, setMapType] = useState("hybrid");
  const [cityCoords, setCityCoords] = useState(null);

  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_APIKEY,
    libraries: ["places"],
  });

  const handleMapClick = (e) => {

    if (boundaryPoints.length < 4) {

      const newPoints = [
        ...boundaryPoints,
        {
          latitude: e.latLng.lat(),
          longitude: e.latLng.lng(),
        },
      ];

      setBoundaryPoints(newPoints);

      if (newPoints.length >= 3) {
        calculatePolygonArea(newPoints);
      }

    } else {
      alert("4 points already selected");
    }

  };

  const calculatePolygonArea = (points) => {

    const R = 6378137;
    let area = 0;

    for (let i = 0; i < points.length; i++) {

      const p1 = points[i];
      const p2 = points[(i + 1) % points.length];

      const lat1 = (p1.latitude * Math.PI) / 180;
      const lat2 = (p2.latitude * Math.PI) / 180;
      const lon1 = (p1.longitude * Math.PI) / 180;
      const lon2 = (p2.longitude * Math.PI) / 180;

      area += (lon2 - lon1) * (2 + Math.sin(lat1) + Math.sin(lat2));

    }

    area = (area * R * R) / 2;

    const sqm = Math.abs(area);
    const sqft = sqm * 10.7639;

    setPlotArea(Math.round(sqft));
  };

  const onMarkerDragEnd = (index, e) => {

    const updated = [...boundaryPoints];

    updated[index] = {
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
    };

    setBoundaryPoints(updated);
    calculatePolygonArea(updated);
  };

  // const openMapAndFocus = () => {

  //   if (!cityCoords) {
  //     alert("Please select location first");
  //     return;
  //   }

  //   setMapModal(true);
  // };

  const openMapAndFocus = () => {

    if (!cityCoords) {
      alert("Please select location first");
      return;
    }

    setMapCenter({
      lat: cityCoords.latitude,
      lng: cityCoords.longitude
    });

    setMapModal(true);
  };

  const goToCurrentLocation = () => {

    navigator.geolocation.getCurrentPosition((pos) => {

      // const coords = {
      //   latitude: pos.coords.latitude,
      //   longitude: pos.coords.longitude,
      // };

      const coords = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      };

      // mapRef.current.panTo(coords);
      mapRef.current.panTo({
        lat: coords.lat,
        lng: coords.lng
      });
    });
  };





  const fetchCategories = async () => {
    const { data } = await axios.get(`${API}/api/new/property-categories`);
    setCategoriesP(data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);



  // const [formData, setFormData] = useState({
  //   zoneId: '',
  //   name: '',
  //   area: '',
  //   plots: 0,
  //   size: '',
  //   facing: 'E',       // just plain JS string
  //   layoutImage: null, // plain JS null
  //   documents: [],     // plain JS array
  // });


  const [formData, setFormData] = useState({
    zone_code: "",
    title: "",
    location: "",
    price: "",
    area: "",
    category: "",
    description: "",
    nearby: "",
    propertyImages: [],        // NEW uploads (File[])
    propertyDocuments: [],     // NEW uploads (File[])

    existingImages: [],        // URLs
    existingDocuments: [],     // URLs
  });



  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const fd = new FormData();

  //   fd.append("zone_code", formData.zone_code);
  //   fd.append("nearby", formData.nearby);
  //   fd.append("zone_desc", getZoneName(formData.zone_desc));
  //   fd.append("title", formData.title);
  //   fd.append("location", formData.location);
  //   fd.append("price", formData.price);
  //   fd.append("area", formData.area);
  //   fd.append("category", formData.category);
  //   fd.append("description", formData.description);

  //   fd.append("existingImages", JSON.stringify(formData.existingImages));
  //   fd.append("existingDocuments", JSON.stringify(formData.existingDocuments));

  //   fd.append("boundary_points", JSON.stringify(boundaryPoints));
  //   fd.append("plot_area", plotArea);

  //   formData.propertyImages.forEach((img) => {
  //     if (img) fd.append("profile_photo", img);
  //   });

  //   formData.propertyDocuments.forEach((doc) => {
  //     fd.append("property_docs", doc);
  //   });

  //   if (editingProject) {
  //     await axios.put(
  //       `${API_BASE}/put/owner/properties/${editingProject.id}`,
  //       fd
  //     );
  //     alert("Property updated");
  //   } else {
  //     // fd.append("user_id", user.id); // logged in user
  //     await axios.post(`${API_BASEE}/api/owner/properties`, fd);
  //     alert("Property created");
  //   }

  //   //fetchProjects();
  //   resetForm();
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();

    fd.append("zone_code", formData.zone_code);
    fd.append("nearby", formData.nearby);
    fd.append("zone_desc", getZoneName(formData.zone_desc));
    fd.append("title", formData.title);
    fd.append("location", formData.location);
    fd.append("price", formData.price);
    fd.append("area", formData.area);
    fd.append("category", formData.category);
    fd.append("description", formData.description);

    // ✅ NEW FIELDS
    fd.append("layout_approval", formData.layoutApproval);
    fd.append("rera", formData.rera);
    fd.append("lrs_paid", formData.lrsPaid);
    fd.append("clear_title", formData.clearTitle);
    fd.append("property_type", formData.propertyType);

    fd.append("existingImages", JSON.stringify(formData.existingImages));
    fd.append("existingDocuments", JSON.stringify(formData.existingDocuments));

    fd.append("boundary_points", JSON.stringify(boundaryPoints));
    fd.append("plot_area", plotArea);

    formData.propertyImages.forEach((img) => {
      if (img) fd.append("profile_photo", img);
    });

    formData.propertyDocuments.forEach((doc) => {
      if (doc) fd.append("property_docs", doc);
    });

    if (editingProject) {
      await axios.put(
        `${API_BASE}/put/owner/properties/${editingProject.id}`,
        fd
      );
      alert("Property updated");
    } else {
      await axios.post(`${API_BASE}/api/owner/properties`, fd);
      alert("Property created");
    }

    resetForm();
  };


  const resetForm = () => {
    setFormData({
      zone_code: "",
      title: "",
      location: "",
      price: "",
      area: "",
      category: "",
      description: "",

      propertyImages: [],
      propertyDocuments: [],
      existingImages: [],
      existingDocuments: [],
    });

    setEditingProject(null);
    setIsFormOpen(false);
  };


  const handleEdit1 = (p) => {
    setEditingProject(p);
    setFormData({
      zoneId: p.zone_code,
      name: p.project_name,
      area: p.project_area,
      plots: p.no_of_plots,
      size: p.plot_size,
      facing: p.facing,
      nearby: p.nearby,

      // NEW
      layoutImage: null,              // only for new upload
      existingLayout: p.layout_image, // existing image URL
      documents: [],                  // new uploads
      existingDocuments: Array.isArray(p.documents)
        ? p.documents
        : JSON.parse(p.documents || "[]")

    });
    setIsFormOpen(true);
  };
  const handleEdit2 = (p) => {
    setEditingProject(p);
    setFormData({
      zoneId: p.zone_code,
      name: p.title,
      area: p.location,
      size: p.area,
      price: p.price,
      category: p.category,

      existingImages: p.property_images || [],
      existingDocuments: p.property_documents || [],

      propertyImages: [],
      propertyDocuments: [],
    });
    setIsFormOpen(true);
  };

  const handleEdit3 = (p) => {
    setEditingProject(p);

    setFormData({
      zone_code: p.zone_code,
      title: p.title,
      location: p.location,
      price: p.price,
      area: p.area,
      category: p.category,
      description: p.description || "",

      existingImages: JSON.parse(p.property_images || "[]"),
      existingDocuments: JSON.parse(p.property_documents || "[]"),

      propertyImages: [],
      propertyDocuments: [],
    });

    setIsFormOpen(true);
  };


  const handleEdit4 = (p) => {
    setEditingProject(p);

    // Safely parse property_images and property_documents with error handling
    const parseJsonSafely = (data) => {
      try {
        return Array.isArray(data) ? data : JSON.parse(data);
      } catch (error) {
        // Return an empty array or handle the case where the JSON is invalid
        console.error("Failed to parse JSON data", error);
        return [];
      }
    };

    setFormData({
      zone_code: p.zone_code,
      title: p.title,
      location: p.location,
      price: p.price,
      area: p.area,
      category: p.category,
      description: p.description || "",

      // Safely parse the existing images and documents
      existingImages: parseJsonSafely(p.property_images || []),
      existingDocuments: parseJsonSafely(p.property_documents || []),

      propertyImages: [],
      propertyDocuments: [],
    });

    setIsFormOpen(true);
  };

  // const handleEdit = (p) => {
  //   setEditingProject(p);

  //   // Safely parse property_images and property_documents with error handling
  //   const parseJsonSafely = (data) => {
  //     try {
  //       return Array.isArray(data) ? data : JSON.parse(data);
  //     } catch (error) {
  //       // Return an empty array or handle the case where the JSON is invalid
  //       console.error("Failed to parse JSON data", error);
  //       return [];
  //     }
  //   };

  //   // Assuming category_id is stored in formData and category_name is the value we need to map to
  //   const selectedCategory = categoriesP.find((category) => category.category_name === p.category) || {};
  //   const selectedOwner = propertyOwners.find((owner) => owner.user_id === p.user_id) || {};

  //   setFormData({
  //     zone_code: p.zone_code,
  //     title: p.title,
  //     location: p.location,
  //     price: p.price,
  //     area: p.area,
  //     category: p.category, // We can use category_name to display in the dropdown
  //     category_id: selectedCategory.id || '', // Assuming categoriesP has id field to store the category's id
  //     description: p.description || "",

  //     existingImages: parseJsonSafely(p.property_images || []),
  //     existingDocuments: parseJsonSafely(p.property_documents || []),

  //     propertyImages: [],
  //     propertyDocuments: [],

  //     // Set the user_id of the selected owner
  //     user_id: p.user_id || selectedOwner.user_id,  // This will auto-populate the property owner field
  //   });

  //   setIsFormOpen(true);
  // };

  const handleEdit = (p) => {
    setEditingProject(p);

    const parseJsonSafely = (data) => {
      try {
        return Array.isArray(data) ? data : JSON.parse(data);
      } catch (error) {
        console.error("Failed to parse JSON data", error);
        return [];
      }
    };

    const selectedCategory =
      categoriesP.find((c) => c.category_name === p.category) || {};

    const selectedOwner =
      propertyOwners.find((o) => o.user_id === p.user_id) || {};

    // ✅ MAP BOUNDARY DATA
    let parsedBoundary = [];
    try {
      parsedBoundary = JSON.parse(p.boundary_points || "[]");
    } catch {
      parsedBoundary = [];
    }

    setBoundaryPoints(parsedBoundary);
    setPlotArea(p.plot_area || 0);

    // ✅ IMPORTANT: SET ALL FIELDS
    setFormData({
      zone_code: p.zone_code || "",
      zone_desc: p.zone_desc || "",
      nearby: p.nearby || "",

      title: p.title || "",
      location: p.location || "",
      price: p.price || "",
      area: p.area || "",

      category: p.category || "",
      category_id: selectedCategory.id || "",

      description: p.description || "",

      // ✅ NEW FIELDS (THIS WAS MISSING)
      layoutApproval: p.layout_approval || "",
      rera: p.rera || "",
      lrsPaid: p.lrs_paid || "",
      clearTitle: p.clear_title || "",
      propertyType: p.property_type || "",

      // ✅ MEDIA
      existingImages: parseJsonSafely(p.property_images),
      existingDocuments: parseJsonSafely(p.property_documents),

      propertyImages: [],
      propertyDocuments: [],

      user_id: p.user_id || selectedOwner.user_id || "",
    });

    setIsFormOpen(true);
  };
  // const handleDelete = (id) => {
  //   if (window.confirm('Are you sure you want to delete this project?')) {
  //     deleteProject(id);
  //     alert('Project deleted successfully');
  //   }
  // };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `https://api.propertygalleria.in/master/api/delete/owner/properties/${id}`,
        {
          method: "DELETE",
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert(data.message);
        // remove item from UI (important)
        // setProjects(prev => prev.filter(p => p.id !== id));
      } else {
        alert(data.message || "Failed to delete");
      }
    } catch (error) {
      console.error(error);
      alert("Error deleting property");
    }
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      if (e.target.name === 'layout') {
        setFormData({ ...formData, layoutImage: files[0] });
      } else if (e.target.name === 'documents') {
        setFormData({ ...formData, documents: Array.from(files) });
      }
    }
  };

  const filteredProjects = projects.filter((p) =>
    (p.zone_code || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (p.location || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (p.title || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (p.category || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (p.price || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (p.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
     (p.property_type || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (p.nearby || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(p.id).includes(searchTerm)
  );

  const getZoneName = (zoneCode) => {
    const z = zones.find((z) => z.zone_code === zoneCode);
    return z ? z.zone_desc : zoneCode;
  };


  // in here modal code 

  const openMediaModal = (project) => {
    setSelectedMedia({
      images: project.property_images || [],
      documents: project.property_documents || [],
    });
    setMediaModalOpen(true);
  };


  const openAgentModal = (project) => {
    console.log('this is project', project)

    const agent = projectHeads.find(
      // (a) => a.user_id === project.handling_agent_id
      (a) => a.user_id === project.handling_head_id
    );

    const owner = propertyOwners.find(
      (a) => a.user_id === project.user_id
    );

    setSelectedAgent(agent);
    setSelectedOwner(owner);
    setAgentModalOpen(true);
  };


  // Inline styles
  const styles = {
    container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
    header: { marginBottom: '24px' },
    title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
    subtitle: { color: '#666' },
    actionsBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', gap: '16px' },
    searchInputWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#999' },
    searchInput: { width: '100%', padding: '8px 12px 8px 32px', border: '1px solid #ccc', borderRadius: '8px', outline: 'none' },
    button: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: '#fff', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', border: 'none' },
    formContainer: { backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
    formTitle: { fontSize: '20px', fontWeight: 600, marginBottom: '16px', color: '#0B1C3D' },
    label: { display: 'block', fontSize: '14px', fontWeight: 500, marginBottom: '4px', color: '#333', textAlign: 'left' },
    input: { width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '8px', marginBottom: '12px', outline: 'none' },
    select: { width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '8px', marginBottom: '12px', outline: 'none' },
    fileInfo: { fontSize: '12px', color: 'green', marginTop: '4px' },
    submitButton: { backgroundColor: '#8b306d', color: '#fff', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
    cancelButton: { backgroundColor: '#ccc', color: '#333', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { padding: '12px', textAlign: 'center', backgroundColor: '#8b306d', color: '#fff' },
    td: { padding: '12px', borderBottom: '1px solid #ddd', verticalAlign: 'center',fontSize:'12px' },
    actionButton: { padding: '4px', borderRadius: '6px', cursor: 'pointer', border: 'none', marginLeft: '4px' },
    facingBadge: {
      fontSize: '10px', display: 'inline-flex', justifyContent: 'center', alignItems: 'center', width: '50px', height: '32px', borderRadius: '10%',
      // backgroundColor: '#E0F0FF',
      color: '#42987e', fontWeight: 600
    },
    stats: { marginTop: '16px', fontSize: '14px', color: '#666', textAlign: 'right' },
  };

  console.log('this is propertyOwners', propertyOwners)


  // this is property approvel 

  const [selectedForApproval, setSelectedForApproval] = useState([]);

  const toggleApproval = (id, checked) => {
    if (checked) {
      setSelectedForApproval(prev => [...prev, id]);
    } else {
      setSelectedForApproval(prev => prev.filter(pid => pid !== id));
    }
  };
  const renderStatus = (project) => {
    const status = project.status?.toLowerCase();

    if (status === "approved") {
      return (
        <span style={{
          background: "#198754",
          color: "#fff",
          padding: "6px 12px",
          borderRadius: "14px",
          fontSize: 12
        }}>
          Approved
        </span>
      );
    }

    if (status === "sold") {
      return (
        <span style={{
          background: "#dc3545",
          color: "#fff",
          padding: "6px 12px",
          borderRadius: "14px",
          fontSize: 12
        }}>
          Sold
        </span>
      );
    }

    // Pending
    return (
      <label>
        <input
          type="checkbox"
          checked={selectedForApproval.includes(project.id)}
          onChange={(e) =>
            toggleApproval(project.id, e.target.checked)
          }
        />
        Approve
      </label>
    );
  };

  // const submitApproval = async () => {
  //   try {
  //     await axios.post(`${API_BASEE}/api/owner/properties/approve`, {
  //       ids: selectedForApproval,
  //       status: "approved"
  //     });

  //     alert("Properties approved");
  //     setSelectedForApproval([]);
  //     window.location.reload();
  //   } catch (err) {
  //     console.error(err);
  //     alert("Approval failed");
  //   }
  // };


  const submitApproval = async () => {
    try {
      await Promise.all(
        selectedForApproval.map((id) =>
          axios.put(
            `${API_BASE}/api/owner/properties/${id}/status`,
            { status: "Approved" }
          )
        )
      );

      alert("Properties approved");

      setSelectedForApproval([]);
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Approval failed");
    }
  };


  const handleMediaSelection = (type, file) => {
    if (type === "image") {
      setSelectedMedia((prev) => {
        const newImages = prev.images.includes(file)
          ? prev.images.filter((img) => img !== file)
          : [...prev.images, file];
        return { ...prev, images: newImages };
      });
    } else if (type === "document") {
      setSelectedMedia((prev) => {
        const newDocuments = prev.documents.includes(file)
          ? prev.documents.filter((doc) => doc !== file)
          : [...prev.documents, file];
        return { ...prev, documents: newDocuments };
      });
    }
  };
  const openFileDialog = (type, index) => {
    // Create an input element dynamically to open file picker
    const input = document.createElement("input");
    input.type = "file";
    input.accept = type === "image" ? "image/*" : "application/pdf";

    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        if (type === "image") {
          const updatedImages = [...formData.existingImages];
          updatedImages[index] = URL.createObjectURL(file);  // Use the object URL for preview
          setFormData({ ...formData, existingImages: updatedImages });
        } else if (type === "document") {
          const updatedDocuments = [...formData.existingDocuments];
          updatedDocuments[index] = URL.createObjectURL(file);  // Use the object URL for preview
          setFormData({ ...formData, existingDocuments: updatedDocuments });
        }
      }
    };

    input.click(); // Trigger file picker
  };


  // pagenation

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedLeads = filteredProjects.slice(
    startIndex,
    startIndex + itemsPerPage
  );


  console.log('this is paginatedLeads', paginatedLeads)
  if (!isLoaded) {
    return <div>Loading Map...</div>;
  }
  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>Property Master</h1>
        <p style={styles.subtitle}>Manage real estate projects and property details</p>
      </div>

      {/* Actions Bar */}
      <div style={styles.actionsBar}>
        <div style={styles.searchInputWrapper}>
          <Search size={20} style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search projects..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
        <button style={styles.button} onClick={() => setIsFormOpen(true)}>
          <Plus size={20} /> Add Project
        </button>
      </div>

      {/* Form */}
      {isFormOpen && (
        <div style={styles.formContainer}>
          <h2 style={styles.formTitle}>{editingProject ? 'Edit Project' : 'Create New Project'}</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: '16px' }}>

              {/* <div>
                <label style={styles.label}>Property Owner Allocation *</label>
                <select
                  value={formData.user_id}
                  onChange={(e) =>
                    setFormData({ ...formData, user_id: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select Owner</option>
                  {propertyOwners.map((owner) => (
                    <option key={owner.user_id} value={owner.user_id}>
                      {owner.full_name}
                    </option>
                  ))}
                </select>
              </div> */}

              <div>

                <label style={styles.label}>HighWay  *</label>

                <select
                  value={formData.zone_code}
                  onChange={(e) => {
                    const selectedZone = zones.find(
                      (z) => z.zone_code === e.target.value
                    );

                    setFormData({
                      ...formData,
                      zone_code: selectedZone.zone_code,
                      zone_desc: selectedZone.zone_desc,
                    });
                  }}
                  style={styles.select}
                  required
                >
                  <option value="">Select HighWay</option>

                  {zones.map((zone) => (
                    <option key={zone.zone_code} value={zone.zone_code}>
                      {zone.zone_desc}
                    </option>
                  ))}
                </select>


              </div>

              <div>
                <label style={styles.label}>Near By</label>
                <select
                  value={formData.nearby}
                  onChange={(e) => setFormData({ ...formData, nearby: e.target.value })}
                  style={styles.select}
                >
                  <option value="Select Ring Road">Select Ring Road </option>
                  <option value="IRR Inner Ring Road">IRR Inner Ring Road</option>
                  <option value="ORR Outer Ring Road">ORR Outer Ring Road</option>
                  <option value="RRR Regional Ring Road">RRR Regional Ring Road</option>

                </select>
              </div>


              <div>
                <label style={styles.label}>Project Name *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  placeholder="e.g., Green Valley Residency"
                  style={styles.input}
                  required
                />
              </div>


              <div>
                <label style={styles.label}>Project Area *</label>
                {/* <input
                  type="text"
                  value={formData.location}
                  onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                  placeholder="e.g., Gurgaon"
                  style={styles.input}
                  required
                /> */}
                {/* <Autocomplete
                  apiKey="YOUR_GOOGLE_API_KEY"
                  onPlaceSelected={(place) => {

                    const address = place.formatted_address;

                    setFormData({
                      ...formData,
                      location: address
                    });

                    if (place.geometry) {

                      const lat = place.geometry.location.lat();
                      const lng = place.geometry.location.lng();

                      setCityCoords({
                        latitude: lat,
                        longitude: lng
                      });

                      setMapCenter({
                        lat: lat,
                        lng: lng
                      });

                    }

                  }}
                  options={{
                    types: ["(regions)"],
                    componentRestrictions: { country: "in" },
                  }}
                  style={styles.input}
                /> */}

                <Autocomplete
                  value={formData.location} // ✅ ADD THIS
                  onChange={(e) =>
                    setFormData({ ...formData, location: e.target.value })
                  }
                  onPlaceSelected={(place) => {

                    const address = place.formatted_address;

                    setFormData({
                      ...formData,
                      location: address
                    });

                    if (place.geometry) {

                      const lat = place.geometry.location.lat();
                      const lng = place.geometry.location.lng();

                      setCityCoords({
                        latitude: lat,
                        longitude: lng
                      });

                      setMapCenter({
                        lat: lat,
                        lng: lng
                      });

                    }

                  }}
                  options={{
                    types: ["(regions)"],
                    componentRestrictions: { country: "in" },
                  }}
                  style={styles.input}
                />


              </div>
              <button
                type="button"
                onClick={openMapAndFocus}
                style={{
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid #ddd",
                  width: "100%",
                  background: boundaryPoints.length === 4 ? "#10b981" : "#f9fafb"
                }}
              >
                {boundaryPoints.length === 4
                  ? "Boundary Marked ✅"
                  : "Select 4 Corners on Map"}
              </button>

              {mapModal && (

                <div style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0,0,0,0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 999
                }}>

                  <div style={{
                    width: "90%",
                    maxWidth: 900,
                    background: "#fff",
                    borderRadius: 12,
                    padding: 20
                  }}>

                    <h3>Mark Plot Boundaries</h3>

                    {boundaryPoints.length >= 3 && (
                      <div style={{
                        background: "#f3f4f6",
                        padding: 10,
                        borderRadius: 8,
                        marginBottom: 10,
                        fontWeight: 600
                      }}>
                        Area : {plotArea} sq ft
                      </div>
                    )}

                    {/* <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "500px" }}
                      center={mapCenter}
                      zoom={16}
                      onClick={handleMapClick}
                      mapTypeId={mapType}
                      onLoad={(map) => mapRef.current = map}
                    > */}
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "500px" }}
                      center={mapCenter}
                      zoom={16}
                      onClick={handleMapClick}
                      mapTypeId={mapType}
                      onLoad={(map) => (mapRef.current = map)}
                    >

                      {boundaryPoints.map((point, index) => (
                        <Marker
                          key={index}
                          position={{
                            lat: point.latitude,
                            lng: point.longitude
                          }}
                          draggable
                          onDragEnd={(e) => onMarkerDragEnd(index, e)}
                          label={(index + 1).toString()}
                        />
                      ))}

                      {boundaryPoints.length > 2 && (
                        <Polygon
                          path={boundaryPoints.map(p => ({
                            lat: p.latitude,
                            lng: p.longitude
                          }))}
                          options={{
                            fillColor: "rgba(66,152,126,0.3)",
                            strokeColor: "#42987e",
                            strokeWeight: 3
                          }}
                        />
                      )}

                    </GoogleMap>
                    {/* <div style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 15,
                      flexWrap: "wrap"
                    }}>

                      <button onClick={() => setMapType("roadmap")}>Standard</button>
                      <button onClick={() => setMapType("hybrid")}>Hybrid</button>
                      <button onClick={() => setMapType("satellite")}>Satellite</button>
                      <button onClick={goToCurrentLocation}>My Location</button>

                    </div> */}


                    {/* <button
                      style={{
                        marginTop: 10,
                        padding: 12,
                        width: "100%",
                        background: "#10b981",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8
                      }}
                      onClick={() => {

                        if (boundaryPoints.length === 4) {
                          setMapModal(false);
                        } else {
                          alert("Select 4 corners");
                        }

                      }}
                    >
                      Confirm Location
                    </button> */}

                    <div style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 15
                    }}>

                      <button
                        style={{
                          flex: 1,
                          padding: 12,
                          background: "#ef4444",
                          color: "#fff",
                          border: "none",
                          borderRadius: 8
                        }}
                        onClick={() => {
                          setBoundaryPoints([]);
                          setPlotArea(0);
                        }}
                      >
                        Clear
                      </button>

                      <button
                        style={{
                          flex: 2,
                          padding: 12,
                          background: "#10b981",
                          color: "#fff",
                          border: "none",
                          borderRadius: 8
                        }}
                        onClick={() => {
                          if (boundaryPoints.length === 4) {
                            setMapModal(false);
                          } else {
                            alert("Select 4 corners");
                          }
                        }}
                      >
                        Confirm Location
                      </button>

                    </div>

                  </div>
                </div>
              )}

              {/* <div>
                <label style={styles.label}>Number of Plots</label>
                <input
                  type="number"
                  value={formData.plots}
                  onChange={(e) => setFormData({ ...formData, plots: parseInt(e.target.value) || 0 })}
                  placeholder="50"
                  style={styles.input}
                />
              </div> */}

              <div>
                <label style={styles.label}>Price</label>
                <input
                  type="text"
                  value={formData.price}
                  onChange={(e) =>
                    setFormData({ ...formData, price: e.target.value })
                  }
                  style={styles.input}
                />

              </div>

              <div>
                <label style={styles.label}>Size</label>
                <input
                  type="text"
                  value={formData.area}
                  onChange={(e) => setFormData({ ...formData, area: e.target.value })}
                  placeholder="e.g., 2400 sq ft"
                  style={styles.input}
                />
              </div>
              <div>
                {/* <label style={styles.label}>Category *</label>
                <select
                  value={formData.category}
                  onChange={(e) =>
                    setFormData({ ...formData, category: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select Category</option> */}
                {/* {zones.map((zone) => (
                    <option key={zone.zone_code} value={zone.zone_code}>
                      {zone.zone_desc}
                    </option>
                  ))} */}
                {/* {categoriesP.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.category_name}
                    </option>
                  ))}
                </select> */}

                <label style={styles.label}>Category *</label>

                <select
                  value={formData.category_id}

                  onChange={(e) => {
                    const selected = categoriesP.find(
                      (c) => c.id === Number(e.target.value)
                    );

                    setFormData({
                      ...formData,
                      category_id: selected.id,
                      category: selected.category_name,
                    });
                  }}
                  style={styles.select}
                  required
                >
                  <option value="">Select Category</option>

                  {categoriesP.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.category_name}
                    </option>
                  ))}
                </select>

              </div>
              <div>
                <label style={styles.label}>Layout Approval *</label>
                <select
                  value={formData.layoutApproval}
                  onChange={(e) =>
                    setFormData({ ...formData, layoutApproval: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select Approval</option>
                  <option value="FCDA">FCDA</option>
                  <option value="HMDA">HMDA</option>
                  <option value="DTCP">DTCP</option>
                  <option value="MUDA">MUDA</option>
                </select>
              </div>
              <div>
                <label style={styles.label}>RERA Approved *</label>
                <select
                  value={formData.rera}
                  onChange={(e) =>
                    setFormData({ ...formData, rera: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div>
                <label style={styles.label}>LRS Paid *</label>
                <select
                  value={formData.lrsPaid}
                  onChange={(e) =>
                    setFormData({ ...formData, lrsPaid: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <div>
                <label style={styles.label}>Clear Title *</label>
                <select
                  value={formData.clearTitle}
                  onChange={(e) =>
                    setFormData({ ...formData, clearTitle: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div>
                <label style={styles.label}>Type of Property *</label>
                <select
                  value={formData.propertyType}
                  onChange={(e) =>
                    setFormData({ ...formData, propertyType: e.target.value })
                  }
                  style={styles.select}
                  required
                >
                  <option value="">Select Property Type</option>
                  <option value="Open Plots/Villa Plots">Open Plots/Villa Plots</option>
                  {/* <option value="Villa Plots">Villa Plots</option> */}
                  <option value="Flats">Flats</option>
                  <option value="Villas">Villas</option>
                  <option value="Farm Land">Farm Land</option>
                  <option value="Houses">Houses</option>
                </select>
              </div>


              <div>
                <label style={styles.label}>Description *</label>
                <input
                  type="text"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  placeholder="e.g., description "
                  style={styles.input}
                  required
                />
              </div>

              {/* <div>
                <label style={styles.label}>Facing Direction</label>
                <select
                  value={formData.facing}
                  onChange={(e) => setFormData({ ...formData, facing: e.target.value })}
                  style={styles.select}
                >
                  <option value="E">East (E)</option>
                  <option value="N">North (N)</option>
                  <option value="S">South (S)</option>
                  <option value="W">West (W)</option>
                </select>
              </div>
 */}

              <label style={styles.label}>Property Images (max 10)</label>

              {formData.propertyImages.map((img, i) => (
                <input
                  key={i}
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const files = [...formData.propertyImages];
                    files[i] = e.target.files[0];
                    setFormData({ ...formData, propertyImages: files });
                  }}
                  style={styles.input}
                />
              ))}

              {formData.propertyImages.length < 10 && (
                <button
                  type="button"
                  onClick={() =>
                    setFormData({
                      ...formData,
                      propertyImages: [...formData.propertyImages, null],
                    })
                  }
                  style={{ ...styles.button, width: "fit-content" }}
                >
                  ➕ Add Image
                </button>
              )}
              <label style={styles.label}>Property Documents (PDF – max 10)</label>

              {formData.propertyDocuments.map((doc, i) => (
                <input
                  key={i}
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => {
                    const docs = [...formData.propertyDocuments];
                    docs[i] = e.target.files[0];
                    setFormData({ ...formData, propertyDocuments: docs });
                  }}
                  style={styles.input}
                />
              ))}

              {formData.propertyDocuments.length < 10 && (
                <button
                  type="button"
                  onClick={() =>
                    setFormData({
                      ...formData,
                      propertyDocuments: [...formData.propertyDocuments, null],
                    })
                  }
                  style={{ ...styles.button, width: "fit-content" }}
                >
                  ➕ Add Document
                </button>
              )}


              <div>
                <label style={styles.label}>Existing Property Images</label>
                {formData.existingImages.map((img, i) => (
                  <div key={i} style={{ marginBottom: "8px" }}>
                    <input
                      type="checkbox"
                      checked={selectedMedia.images.includes(img)}
                      onChange={() => handleMediaSelection("image", img)}
                    />
                    <span style={{ marginLeft: "8px" }}>
                      <img
                        src={img}
                        alt={`Property ${i + 1}`}
                        style={{
                          width: "100px",
                          height: "75px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                        onClick={() => openFileDialog("image", i)}
                      />
                    </span>
                  </div>
                ))}
              </div>

              <div>
                <label style={styles.label}>Existing Property Documents</label>
                {formData.existingDocuments.map((doc, i) => (
                  <div key={i} style={{ marginBottom: "8px" }}>
                    <input
                      type="checkbox"
                      checked={selectedMedia.documents.includes(doc)}
                      onChange={() => handleMediaSelection("document", doc)}
                    />
                    <span style={{ marginLeft: "8px" }}>
                      <a href={doc} target="_blank" rel="noopener noreferrer">
                        Document {i + 1}
                      </a>
                    </span>
                  </div>
                ))}
              </div>



            </div>

            <div style={{ marginTop: '16px' }}>
              <button type="submit" style={styles.submitButton}>
                {editingProject ? 'Update Project' : 'Create Project'}
              </button>
              <button type="button" onClick={resetForm} style={styles.cancelButton}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Table */}
      <div style={{ overflowX: 'auto', border: '1px solid #ccc', borderRadius: '8px' }}>
        <table style={styles.table}>
          <thead style={{ backgroundColor: '#8b306d', color: '#fff' }}>
            <tr>
              <th style={styles.th}>Project ID</th>
              <th style={styles.th}>Highway</th>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Location</th>
              <th style={styles.th}>Type of Property</th>
              <th style={styles.th}>NearBy</th>
              <th style={styles.th}>Category</th>
              <th style={styles.th}>Size</th>
              <th style={styles.th}>Price</th>
              <th style={styles.th}>Layout</th>
              <th style={styles.th}>Actions</th>
              <th style={styles.th}>Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedLeads.length === 0 ? (
              <tr>
                <td colSpan={9} style={{ padding: '24px', textAlign: 'center', color: '#666' }}>
                  {searchTerm
                    ? 'No projects found matching your search'
                    : 'No projects created yet. Click "Add Project" to get started.'}
                </td>
              </tr>
            ) : (
              paginatedLeads.map((project, index) => (
                <tr key={project.id} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                  <td style={styles.td}>{index+1}</td>
                  <td style={styles.td}>{getZoneName(project.zone_code)}</td>
                  <td style={styles.td}>{project.title}</td>
                  <td style={styles.td}>{project.location}</td>
                  <td style={styles.td}>{project.property_type}</td>
                  <td style={styles.td}>{project.nearby || '--'}</td>
                  <td style={styles.td}>{project.category}</td>
                  <td style={styles.td}>{project.area}</td>
                  <td style={styles.td}> {project.price}
                  </td>

                  <td style={styles.td}>
                    <button
                      style={styles.actionButton}
                      onClick={() => openMediaModal(project)}
                      title="View Media"
                    >
                      <ImageIcon size={18} />
                    </button>
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      {/* <button
                        style={styles.actionButton}
                        onClick={() => openAgentModal(project)}
                        title="View Agent"
                      >
                        <Eye size={18} />
                      </button> */}

                      <button onClick={() => handleEdit(project)} style={{ ...styles.actionButton, color: '#8b306d' }} title="Edit">
                        <Pencil size={18} />
                      </button>
                      <button onClick={() => handleDelete(project.id)} style={{ ...styles.actionButton, color: '#42987e' }} title="Delete">
                        <Trash size={18} />
                      </button>
                    </div>
                  </td>
                  <td>{renderStatus(project)}</td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {selectedForApproval.length > 0 && (
        <div style={{ marginTop: 16, textAlign: "right" }}>
          <button
            onClick={submitApproval}
            style={{
              background: "#198754",
              color: "#fff",
              padding: "8px 18px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer"
            }}
          >
            Submit Approval
          </button>
        </div>
      )}


      <Modal
        isOpen={mediaModalOpen}
        onRequestClose={() => setMediaModalOpen(false)}
        style={{
          ...modalStyles,
          content: { ...modalStyles.content, width: "800px" },
        }}
      >
        {/* Header */}
        <div style={modalHeader}>
          <h3 style={{ margin: 0 }}>Property Media</h3>
          <button
            onClick={() => setMediaModalOpen(false)}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={modalBody}>
          {/* Images */}
          <h4 style={{ marginBottom: "8px" }}>Images</h4>

          {selectedMedia.images.length === 0 ? (
            <p style={{ color: "#777" }}>No images available</p>
          ) : (
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              {selectedMedia.images.map((img, i) => (
                <div
                  key={i}
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "4px",
                  }}
                >
                  <img
                    src={img}
                    alt="Property"
                    style={{
                      width: "150px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                    onClick={() => window.open(img, "_blank")}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Documents */}
          <h4 style={{ marginTop: "20px" }}>Documents</h4>

          {selectedMedia.documents.length === 0 ? (
            <p style={{ color: "#777" }}>No documents available</p>
          ) : (
            <ul style={{ paddingLeft: "18px" }}>
              {selectedMedia.documents.map((doc, i) => (
                <li key={i} style={{ marginBottom: "6px" }}>
                  <a
                    href={doc}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#8b306d", textDecoration: "none" }}
                  >
                    📄 Document {i + 1}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Modal>


      <Modal
        isOpen={agentModalOpen}
        onRequestClose={() => setAgentModalOpen(false)}
        style={{
          ...modalStyles,
          content: { ...modalStyles.content, width: "500px" },
        }}
      >
        <>
          {/* Header */}
          <div style={modalHeader}>
            <h3 style={{ margin: 0 }}>Property Owner Details</h3>
            <button
              onClick={() => setAgentModalOpen(false)}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "20px",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div style={modalBody}>
            {selectedOwner ? (
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  padding: "14px",
                  background: "#fafafa",
                }}
              >
                <p><b>Name:</b> {selectedOwner.full_name}</p>
                <p><b>Email:</b> {selectedOwner.email}</p>
                <p><b>Phone:</b> {selectedOwner.mobile_number}</p>
                <p><b>Role ID:</b> {selectedOwner.custom_id}</p>
              </div>
            ) : (
              <p style={{ color: "#777" }}>No agent assigned</p>
            )}
          </div>

          {/* <div style={modalHeader}>
          <h3 style={{ margin: 0 }}>Project Head Details</h3>
          <button
            onClick={() => setAgentModalOpen(false)}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div> */}

          {/* Body */}
          {/* <div style={modalBody}>
          {selectedAgent ? (
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "14px",
                background: "#fafafa",
              }}
            >
              <p><b>Name:</b> {selectedAgent.full_name}</p>
              <p><b>Email:</b> {selectedAgent.email}</p>
              <p><b>Phone:</b> {selectedAgent.mobile_number}</p>
              <p><b>Role ID:</b> {selectedAgent.custom_id}</p>
            </div>
          ) : (
            <p style={{ color: "#777" }}>No agent assigned</p>
          )}
        </div> */}





        </>

      </Modal>




      {/* Stats */}
      <div style={styles.stats}>
        Total Projects: {filteredProjects.length}
        {searchTerm && ` (filtered from ${projects.length})`}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          borderTop: "1px solid #E5E7EB",
          background: "#F9FAFB",
        }}
      >
        <div style={{ fontSize: 14, color: "#6B7280" }}>
          Showing {startIndex + 1}–
          {Math.min(startIndex + itemsPerPage, filteredProjects.length)} of{" "}
          {filteredProjects.length}
        </div>

        <div style={{ display: "flex", gap: "6px" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              background: currentPage === 1 ? "#eee" : "#fff",
              cursor: "pointer",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .slice(
              Math.max(0, currentPage - 3),
              Math.min(totalPages, currentPage + 2)
            )
            .map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  background:
                    currentPage === page ? "#8b306d" : "#fff",
                  color: currentPage === page ? "#fff" : "#333",
                  cursor: "pointer",
                }}
              >
                {page}
              </button>
            ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              background:
                currentPage === totalPages ? "#eee" : "#fff",
              cursor: "pointer",
            }}
          >
            Next
          </button>
        </div>
      </div>

    </div>
  );
};
